import styled, { css } from "styled-components";
import { setFlex, setPosition } from "../variables/utils";
import { BREAKPOINTS, desktop, mobile } from "../variables/breakpoints";

const setMarqueePosition = ({ articleId, marqueeId }) => {
  const baseId = parseInt(String(marqueeId).split("-")[0], 10);
  if (articleId === 1) {
    switch (baseId) {
      case 1:
        return css`
          z-index: 2;
          @media (max-width: ${BREAKPOINTS.md}px) {
            bottom: -4px;
            z-index: -1;
          }
        `;
      case 3:
        return css`
          top: -50px;
          z-index: -1;
          @media (max-width: ${BREAKPOINTS.md}px) {
            top: -2px;
          }
        `;
      default:
        return;
    }
  }

  if (articleId === 2) {
    switch (baseId) {
      case 1:
        return css`
          top: 40px;
          z-index: 2;
        `;
      case 3:
        return css`
          top: -80px;
          z-index: -2;
          @media (max-width: ${BREAKPOINTS.md}px) {
            top: 0;
          }
        `;
      default:
        return;
    }
  }

  if (articleId === 3) {
    switch (baseId) {
      case 1:
        return css`
          top: 40px;
          z-index: 2;
        `;
      case 3:
        return css`
          top: -80px;
          z-index: -2;
          @media (max-width: ${BREAKPOINTS.md}px) {
            top: 0;
          }
        `;
      default:
        return;
    }
  }

  return;
};

export const BodyWrapper = styled.div`
  ${setFlex({ direction: "column" })};
  ${setPosition({ position: "relative", zIndex: 1 })};
  min-height: 100vh;
  width: 100%;
`;

export const ParagraphContainer = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  text-align: center;
  width: -webkit-fill-available;
  height: 50vh;
  padding: 2.5rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: auto;
    padding: 8rem 1.5rem;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    padding: 8rem 2rem;
  }
`;

export const Paragraph = styled.div`
  display: inline;
  font-family: editorialnew-regular;
  ${props => props.$primaryColor && `color: ${props.$primaryColor};`};
  .secondary {
    display: inline;
    ${props => props.$secondaryColor && `color: ${props.$secondaryColor};`};
    @media (max-width: ${BREAKPOINTS.sm}px) {
      ${props => props.$primaryColor && `color: ${props.$primaryColor};`};
    }
  }
  max-width: 50vw;
  font-size: 1.5rem;
  line-height: 1.5rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    br {
      display: none;
    }
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    font-size: 1rem;
    line-height: 1.4rem;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    max-width: unset;
    font-size: 1.3rem;
    line-height: 1.6rem;
  }
`;

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${props => setMarqueePosition(props.$marqueePosition)};
  width: 100%;
  margin: auto;
  overflow: hidden;
  ${props => props.$isMobile && mobile};
  ${props => props.$isDesktop && desktop};
`;

export const Container = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({})};
  height: ${({ $desktopHeight, $mobileHeight }) =>
    $desktopHeight ? `${$desktopHeight}vh` : `${$mobileHeight}vh`};
  width: fit-content;
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: ${props => `${props.$mobileHeight}vh`};
  }
`;

export const MarqueeWrapper = styled.div`
  ${setFlex({})};
  overflow: hidden;
`;

export const StyledMarqueeItem = styled.div`
  width: fit-content;
  height: ${({ $desktopHeight, $mobileHeight }) =>
    $desktopHeight ? `${$desktopHeight}vh` : `${$mobileHeight}vh`};
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: ${props => `${props.$mobileHeight}vh`};
  }
`;

export const MarqueeContainer = styled.div`
  ${setFlex({ align: "center", justify: "center" })};
  height: inherit;
`;

export const Image = styled.img`
  width: auto;
  height: 100%;
  max-width: ${props => (props.$logo ? "90px" : "unset")};
  ${props => props.$logo && "padding-bottom: 1rem"};
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
`;

export const FullWidthImage = styled(Image)`
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: auto;
    width: 100%;
  }
`;

export const ImageContainer = styled.div`
  ${setFlex({ align: "center", justify: "center" })};
  max-width: 100vw;
  ${props =>
    props.$bodyImage &&
    setPosition({ position: "relative", top: "-20", zIndex: 1 })};
  @media (max-width: ${BREAKPOINTS.md}px) {
    top: 0;
  }
`;

export const HeadlineImageWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  height: 100%;
`;

export const ImageWrapper = styled.div`
  ${setPosition({ position: "relative", zIndex: 5 })};
  height: 100vh;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: 100%;
  }
`;

export const HeadlineImageContainer = styled.div`
  ${setPosition({ position: "relative", zIndex: 5 })};
  width: 100%;
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${props =>
      props.$primaryColor && `background-color: ${props.$primaryColor};`};
    padding: 2rem;
    width: auto;
  }
`;

export const HeadlineImage = styled(Image)`
  height: auto !important;
  max-width: 12vw !important;
  @media (max-width: ${BREAKPOINTS.xxxl}px) {
    max-width: 10vw !important;
  }
  @media (max-width: ${BREAKPOINTS.xxxl}px) {
    max-width: 15vw !important;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    max-width: 25vw !important;
  }
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: auto;
    width: 100%;
    max-width: unset !important;
    border-radius: 10px;
  }

  will-change: transform;
  transform: translateZ(0);
  transform-style: preserve-3d;
  backface-visibility: hidden;
`;

export const BodyHeadlineContainer = styled.div`
  ${setFlex({ align: "center", justify: "flex-start", direction: "column" })};
  ${props =>
    props.$primaryColor && `background-color: ${props.$primaryColor};`};
  width: 100%;
  min-height: 100vh;
  padding-top: 5rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    margin-top: -1px;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 2.5rem 0;
    min-height: unset;
  }
`;

export const BodyHeadline = styled.div`
  ${setPosition({ position: "relative", zIndex: 10 })};
  ${props => props.$fontColor && `color: ${props.$fontColor};`};

  font-family: akzidenz-grotesk-bold;
  font-size: 4.5rem;
  line-height: 4.5rem;
  text-align: center;
  padding: 5rem 0;
  max-width: 40vw;
  @media (max-width: ${BREAKPOINTS.xxxxl}px) {
    max-width: 45vw;
  }
  @media (max-width: ${BREAKPOINTS.xxxl}px) {
    max-width: 60vw;
  }
  @media (max-width: ${BREAKPOINTS.xlm}px) {
    max-width: 70vw;
  }
  @media (max-width: ${BREAKPOINTS.xl}px) {
    max-width: 75vw;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    max-width: 95vw;
  }
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 2.5rem 0;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    max-width: 80vw;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    max-width: 100vw;
  }

  .headline-image-landing {
    display: inline-block;
    height: 2.5em;
    vertical-align: baseline;
    width: 7vw;
    @media (max-width: ${BREAKPOINTS.lg}px) {
      width: 15vw;
    }
    @media (max-width: ${BREAKPOINTS.md}px) {
      display: none;
    }
  }

  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 2.7rem;
    line-height: 2.7rem;
    padding-bottom: 5rem;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    font-size: 2.5rem;
  }
  @media (max-width: ${BREAKPOINTS.xxs}px) {
    font-size: 1.9rem;
    line-height: 2.5rem;
  }

  @media (max-width: ${BREAKPOINTS.xxxs}px) {
    font-size: 1.6rem;
    line-height: 2rem;
  }
`;

export const BodySliderWrapper = styled.div`
  ${setFlex({ align: "center", justify: "center" })};
  width: 100%;
  height: 100%;
  padding-bottom: 5rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding-bottom: 0;
  }
`;

export const BodySlider = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  height: 80vh;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: auto;
  }
`;

export const BodySlide = styled.div`
  ${setPosition({ position: "absolute" })};
  ${props =>
    props.$slideBackground && `background-color: ${props.$slideBackground};`};
  width: 100%;
  height: 100%;
  padding: 1.5rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setPosition({ position: "unset" })};
    ${setFlex({ align: "center", justify: "center" })};
    height: auto;
    width: auto;
    padding: 2rem;
  }
`;

export const BodySlideImage = styled(Image)`
  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: auto;
    height: 100%;
    max-width: unset;
    border-radius: 10px;
  }
  @media (max-width: ${BREAKPOINTS.md}px) {
    width: 100%;
    height: auto;
  }
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
  will-change: transform;
  transform: translateZ(0);
  transform-style: preserve-3d;
  backface-visibility: hidden;
`;
